import { useNavigate } from 'react-router-dom';
import Layout from '../Components/Layout/Layout'; 
import { 
    ChevronRight,
    User,
    FileText,
    Shield,
    HelpCircle,
    HeadphonesIcon
} from "lucide-react"; 

const More = () => {
    const navigate = useNavigate();

    const menuItems = [
        { id: 'profile', label: 'Profiel', path: '/profile', icon: <User className="text-ps-blue-dark" size={20} /> },
        { id: 'terms', label: 'Algemene voorwaarden', path: '/terms', icon: <FileText className="text-ps-blue-dark" size={20} /> },
        { id: 'privacy', label: 'Privacy', path: '/privacy', icon: <Shield className="text-ps-blue-dark" size={20} /> },
        { id: 'explanation', label: 'Uitleg', path: '/explanation', icon: <HelpCircle className="text-ps-blue-dark" size={20} /> },
        { id: 'helpdesk', label: 'Helpdesk', path: '/helpdesk', icon: <HeadphonesIcon className="text-ps-blue-dark" size={20} /> },
    ];


    const handleNavigation = (path) => {
        navigate(path);
    };

    return (
        <Layout>
            <div className="relative max-w-[1100px] mx-auto">
                <h2 className="text-xl font-normal font-inter text-ps-blue-dark mb-8">Jouw instellingen</h2>

                <div className="space-y-2">
                    {menuItems.map((item) => (
                        <div
                            key={item.id}
                            className="flex items-center justify-between w-full p-4 hover:pl-6 cursor-pointer border-b-[1px] transition-all duration-200"
                            onClick={() => handleNavigation(item.path)}
                        >
                            <div className="flex items-center gap-3">
                                {item.icon}
                                <span className="font-inter">{item.label}</span>
                            </div>
                            <ChevronRight className="text-ps-blue-dark" size={20} />
                        </div>
                    ))}
                </div>



                <div className="text-center text-gray-500 text-sm font-inter mt-8">
                    Versie 1.0.1b
                </div>
            </div>
        </Layout>
    );
};

export default More;